import React from "react";

import { ChartEmptyState } from "../../../../components/States";
import { EmptyInvestmentsStateProps } from "./types";

// Decorative rising line: portfolio value trending up over time. Inherits its
// stroke colour (white) from the illustration's front card via currentColor.
const growthChart = (
  <svg
    width="60"
    height="34"
    viewBox="0 0 60 34"
    fill="none"
    aria-hidden="true"
  >
    <polyline
      points="3,27 17,18 30,21 44,9 57,4"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.95"
    />
    <circle cx="57" cy="4" r="3" fill="currentColor" />
  </svg>
);

const FIRST_RUN_DESCRIPTION =
  "Track stocks, ETFs, funds and more in one place. Create an investment and its value, returns and allocation appear here automatically.";
const FILTERED_DESCRIPTION =
  "No investments match the current filters. Adjust the filters or create a new investment to see it here.";

/**
 * Empty state shown when the user has no investments, or none match the active
 * filters. Wraps the shared ChartEmptyState with investment-specific copy.
 */
export const EmptyInvestmentsState: React.FC<EmptyInvestmentsStateProps> = ({
  onCreateInvestment,
  isFiltered,
  onClearFilters,
}) => {
  const title = isFiltered
    ? "No investments found"
    : "Add your first investment";
  const description = isFiltered ? FILTERED_DESCRIPTION : FIRST_RUN_DESCRIPTION;
  // Offer a one-tap reset only in the filtered "no match" state.
  const showClearFilters = isFiltered && Boolean(onClearFilters);
  const secondaryActionLabel = showClearFilters ? "Clear filters" : undefined;

  return (
    <ChartEmptyState
      chart={growthChart}
      title={title}
      description={description}
      buttonLabel="Create investment"
      onAction={onCreateInvestment}
      ariaLabel="No investments yet"
      secondaryActionLabel={secondaryActionLabel}
      onSecondaryAction={showClearFilters ? onClearFilters : undefined}
    />
  );
};
